import { MainPage } from '@/types'

// Middleware routes
export const walletConnectedRequiredRouteNames = [
  MainPage.Swap,
  MainPage.Incentives,
  MainPage.GridTrading,
  MainPage.GridTradingContract
]
